import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RotateClockwiseAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 22.5H3C2.17192 22.4992 1.50083 21.8281 1.5 21V12C1.50083 11.1719 2.17192 10.5008 3 10.5H12C12.8281 10.5008 13.4992 11.1719 13.5 12V21C13.4992 21.8281 12.8281 22.4992 12 22.5ZM3 12V21H12.0008L12 12H3ZM22.5 11.25L21.4425 10.1925L19.5 12.1275V8.25C19.4967 5.35188 17.1481 3.00331 14.25 3H10.5V4.5H14.25C16.32 4.50248 17.9975 6.17996 18 8.25V12.1275L16.0575 10.1925L15 11.25L18.75 15L22.5 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RotateClockwiseAlt.vue"]]);
